import React from 'react';
import DateInput from '../DateInput/DateInput';
import { toInputDateTime } from '../../utils/dateFormat';
import './DateTimeRange.css';

/**
 * From – to, date and time: the search by when of the logs and reports. value is
 * { from, to } as the inputs keep them ('YYYY-MM-DDTHH:mm', this browser's time);
 * onChange gets the next one. Quick picks: today, the last 24 hours, 7 days, 30 days.
 */
const PRESETS = [
    { key: 'today', label: 'Today', range: (now) => { const d = new Date(now); d.setHours(0, 0, 0, 0); return [d, null]; } },
    { key: '24h', label: '24 hours', range: (now) => [new Date(now - 864e5), null] },
    { key: '7d', label: '7 days', range: (now) => [new Date(now - 7 * 864e5), null] },
    { key: '30d', label: '30 days', range: (now) => [new Date(now - 30 * 864e5), null] },
];

/**
 * The range as the API takes it: ISO times (the server cannot know this browser's
 * time zone — '2026-11-01T10:00' alone would be read as 10:00 UTC there). A date-
 * time string with no zone is this browser's local time.
 */
export function rangeParams({ from, to } = {}) {
    const iso = (value) => {
        if (!value) return undefined;
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
    };
    return { from: iso(from), to: iso(to) };
}

export default function DateTimeRange({ value = {}, onChange, className = '' }) {
    const set = (patch) => onChange?.({ from: value.from || '', to: value.to || '', ...patch });
    const pick = (preset) => {
        const [from, to] = preset.range(Date.now());
        set({ from: toInputDateTime(from), to: to ? toInputDateTime(to) : '' });
    };
    return (
        <div className={`dtr ${className}`.trim()} role="group" aria-label="Date and time">
            <label className="dtr-field">
                <span>From</span>
                <DateInput type="datetime-local" name="from" value={value.from || ''} max={value.to || undefined}
                    onChange={(e) => set({ from: e.target.value })} placeholder="dd/mm/yyyy hh:mm" />
            </label>
            <label className="dtr-field">
                <span>To</span>
                <DateInput type="datetime-local" name="to" value={value.to || ''} min={value.from || undefined}
                    onChange={(e) => set({ to: e.target.value })} placeholder="now" />
            </label>
            <div className="dtr-presets">
                {PRESETS.map((p) => (
                    <button key={p.key} type="button" className="dtr-preset" onClick={() => pick(p)}>{p.label}</button>
                ))}
                {(value.from || value.to) && (
                    <button type="button" className="dtr-preset dtr-clear" onClick={() => set({ from: '', to: '' })}>Any time</button>
                )}
            </div>
        </div>
    );
}
